import jQuery from 'jquery';

function initSlickSlider() {
    jQuery('.beans-slider').each(function() {
    	var item = jQuery(this);
    	var btnPrev = item.find('.btn-prev');
    	var btnNext = item.find('.btn-next');
    	var slider = item.find('.beans-slideset');
    	var pagination = item.find('.beans-pagination');

    	slider.slick({
    		arrows: (btnPrev.length > 0) && (btnNext.length > 0) ? true : false,
    		dots: pagination.length > 0 ? true : false,
    		pauseOnHover: false,
    		autoplay: true,
    		speed: 800
    	});

    	pagination.remove();
    	btnPrev.remove();
    	btnNext.remove();
    });

    jQuery('.beans-stepslider').each(function() {
    	var item = jQuery(this);
    	var btnPrev = item.find('.btn-prev');
    	var btnNext = item.find('.btn-next');
    	var slider = item.find('.beans-slideset');
    	var pagination = item.find('.beans-pagination');

    	slider.slick({
    		arrows: (btnPrev.length > 0) && (btnNext.length > 0) ? true : false,
    		dots: pagination.length > 0 ? true : false,
    		slidesToShow: 1,
    		mobileFirst: true,
    		autoplay: true,
    		responsive: [
    			{
    				breakpoint: 767,
    				settings: {
    					slidesToShow: 2
    				}
    			}, {
					breakpoint: 1024,
    				settings: {
    					slidesToShow: 4
    				}    				
    			}
    		]
    	});

    	if(item.parents('.blog-section , .finest-chef').length > 0) {
    		slider.slick('unslick');
	    	slider.slick({
	    		arrows: (btnPrev.length > 0) && (btnNext.length > 0) ? true : false,
	    		dots: pagination.length > 0 ? true : false,
    			autoplay: true,
	    		slidesToShow: 1,
	    		mobileFirst: true,
	    		responsive: [
	    			{
	    				breakpoint: 768,
	    				settings: {
	    					slidesToShow: 2
	    				}
	    			}, {
						breakpoint: 1024,
	    				settings: {
	    					slidesToShow: 3
	    				}    				
	    			}
	    		]
	    	});
    	}

    	if(item.parents('.related-shop').length > 0) {
    		slider.slick('unslick');
	    	slider.slick({
	    		arrows: (btnPrev.length > 0) && (btnNext.length > 0) ? true : false,
	    		dots: pagination.length > 0 ? true : false,
    			autoplay: true,
    			speed: 1200,
    			autoplaySpeed: 4000,
	    		slidesToShow: 1
	    	});
    	}

    	pagination.remove();
    	btnPrev.remove();
    	btnNext.remove();
    });

    jQuery('.beans-fadeslider').each(function() {
    	var item = jQuery(this);
    	var btnPrev = item.find('.btn-prev');
    	var btnNext = item.find('.btn-next');
    	var slider = item.find('.slideset');
    	var pagination = item.find('.beans-pagination');

    	slider.slick({
    		arrows: (btnPrev.length > 0) && (btnNext.length > 0) ? true : false,
    		dots: pagination.length > 0 ? true : false,
    		pauseOnHover: false,
    		autoplay: true,
    		fade: true,
    		speed: 800
    	});

    	pagination.remove();
    	btnPrev.remove();
    	btnNext.remove();
    });

    jQuery('.beans-stepslider2').each(function() {
    	var item = jQuery(this);
    	var slider = item.find('.beans-slideset');

    	slider.slick({
    		asNavFor: '.beans-pagination ul',
    		pauseOnHover: false,
    		arrows: false,
    		speed: 800
    	});
    });

    jQuery('.beans-pagination').each(function() {
    	var item = jQuery(this);
    	var btnPrev = item.find('.btn-prev');
    	var btnNext = item.find('.btn-next');
    	var slider = item.find('ul');

    	slider.slick({
    		arrows: (btnPrev.length > 0) && (btnNext.length > 0) ? true : false,
    		asNavFor: '.beans-stepslider2 .beans-slideset',
    		focusOnSelect: true,
    		slidesToShow: 1,
    		mobileFirst: true,
    		autoplay: false,
    		responsive: [
    			{
    				breakpoint: 767,
    				settings: {
    					slidesToShow: 2
    				}
    			}, {
					breakpoint: 1024,
    				settings: {
    					slidesToShow: 4
    				}    				
    			}
    		]
    	});
    });
}

// Initialize on document ready
jQuery(document).ready(function() {
    initSlickSlider();
});